import debug from "../debug";
import monday from "./monday";

const log = debug("storage");
let useMondayStorage = false;

export function initStorage({ monday }: { monday: boolean }): void {
    log(`Using Monday: ${monday}`);
    useMondayStorage = monday;
}

export async function saveSet(key: string, set: Set<any>): Promise<void> {
    const value = JSON.stringify(Array.from(set));
    if (useMondayStorage) {
        await monday.storage.instance.setItem(key, value)
    } else {
        localStorage.setItem(key, value);
    }
}

export async function loadSet(key: string): Promise<Set<any> | undefined> {
    let value;
    if (useMondayStorage) {
        const res = await monday.storage.instance.getItem(key);
        value = res.data.value;
    } else {
        value = localStorage.getItem(key);
    }

    if (value !== null) {
        try {
            return new Set(JSON.parse(value));
        } catch (e) {
            log(`Error parsing ${value}`);
            return;
        }
    }
}

export async function saveObject(key: string, object: any[] | never): Promise<void> {
    const value = JSON.stringify(object);
    if (useMondayStorage) {
        await monday.storage.instance.setItem(key, value);
    } else {
        localStorage.setItem(key, value);
    }
}

export async function loadObject(key: string): Promise<any[] | never | undefined> {
    let value;
    if (useMondayStorage) {
        const res = await monday.storage.instance.getItem(key);
        value = res.data.value;
    } else {
        value = localStorage.getItem(key);
    }

    if (value !== null) {
        try {
            return JSON.parse(value);
        } catch (e) {
            log(`Error parsing ${value}`);
            return;
        }
    }
}

export async function removeItem(key: string): Promise<void> {
    if (useMondayStorage) {
        await monday.storage.instance.setItem(key, "null");
    } else {
        localStorage.removeItem(key);
    }
}
